var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserFull = function SvgUserFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 55,
    fill: "#4B5258"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9939 54.9995C63.7427 54.9995 70.835 48.4331 70.835 40.333C70.835 32.2329 63.7427 25.6665 54.9939 25.6665C46.2452 25.6665 39.1529 32.2329 39.1529 40.333C39.1529 48.4331 46.2452 54.9995 54.9939 54.9995Z",
    fill: "#E1D9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9994 59.1906C39.5131 59.1906 26.8216 70.2691 25.666 84.3332H84.3327C83.1771 70.2691 70.4856 59.1906 54.9994 59.1906Z",
    fill: "#E1D9CD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userFull.631f4eb4.svg";
export { ForwardRef as ReactComponent };